import type { Vehicle } from "../types";

export const DEFAULT_VEHICLE_IMAGES = [
  "/default-vehicles/vehicle-1.png",
  "/default-vehicles/vehicle-2.png",
  "/default-vehicles/vehicle-3.png",
  "/default-vehicles/vehicle-4.png",
  "/default-vehicles/vehicle-5.png",
] as const;

export function vehicleImage(vehicle: Pick<Vehicle, "photo">, fallbackIndex = 0) {
  const safeIndex = ((fallbackIndex % DEFAULT_VEHICLE_IMAGES.length) + DEFAULT_VEHICLE_IMAGES.length) % DEFAULT_VEHICLE_IMAGES.length;
  return vehicle.photo || DEFAULT_VEHICLE_IMAGES[safeIndex];
}
